/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { Logger } from '../logger';
import { Request } from '../request';

export class FetchRequest implements Request {
  constructor(private url: string) {}

  public isAvailable(): boolean {
    return typeof window !== 'undefined' && typeof window.fetch !== 'undefined';
  }

  public send(data: string | Uint8Array): boolean {
    Logger.info('send by fetch');

    let body: string | Blob;
    let type = 'application/json; charset=UTF-8';

    if (Object.prototype.toString.call(data) !== '[object String]') {
      body = new Blob([data], { type: 'application/octet-stream' });
      type = 'application/octet-stream';
    } else {
      body = data as string;
    }

    window
      .fetch(this.url, {
        body: body,
        headers: new Headers({
          'Content-Type': type,
        }),
        method: 'POST',
        mode: 'cors',
        redirect: 'follow',
        keepalive: true,
      })
      .then(() => {
        Logger.debug('Event sent');
      });

    return true;
  }
}
